export function isMacOs() {
  const platform = navigator.platform?.toUpperCase();
  const userAgent = navigator.userAgent?.toLowerCase();

  return platform.includes("MAC") || userAgent.includes("macintosh");
}
